// extracted by mini-css-extract-plugin
export var listing = "blog-module--listing--ZOqyx";
export var linkText = "blog-module--link-text--WFc-W";